export const projectOverviewColumns = [
    { accessor: 'id', Header: 'Project ID' },
    { accessor: 'name', Header: 'Project name' },
    { accessor: 'createdBy', Header: 'Created by' },
    { accessor: 'createdAt', Header: 'Created' },
    { id: 'exportAndStats', Header: 'Export' },
    { id: 'actions', Header: 'Actions' },
];
